// extracted by mini-css-extract-plugin
export default {"input":"IconInput_input__kiJIi"};